// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { IconButton } from '../../../atoms/IconButton';
export var ActionCellStructure = function (_a) {
    var className = _a.className, actions = _a.actions, value = _a.value;
    return (React.createElement(Container, { className: className, as: 'td' },
        React.createElement(Container, null, actions &&
            actions.map(function (_a) {
                var name = _a.name, icon = _a.icon, actionHandler = _a.actionHandler;
                return (React.createElement(IconButton, { key: name, ariaLabel: name, icon: icon, size: 'small', shape: 'circle', styleVariant: 'ghost', onClick: function () { return actionHandler(value); } }));
            }))));
};
//# sourceMappingURL=ActionCellStructure.js.map